import { defineComponent as _defineComponent } from 'vue'
import { withModifiers as _withModifiers, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-51088d1f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "x-modal x-modal__device" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "x-modal__container" }
const _hoisted_4 = { class: "x-modal__header" }
const _hoisted_5 = { class: "tabs-header" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "关于本机", -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "硬件信息", -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icomoon-close icon-close" }, null, -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { class: "x-modal__content" }
const _hoisted_13 = {
  key: "basic",
  class: "tab-content"
}
const _hoisted_14 = { class: "about-list" }
const _hoisted_15 = { class: "list-item" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "list-label" }, "设备名称：", -1))
const _hoisted_17 = { class: "list-item" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "list-label" }, "设备ID：", -1))
const _hoisted_19 = { class: "list-content copyable-text" }
const _hoisted_20 = { class: "list-item" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "list-label" }, "设备状态：", -1))
const _hoisted_22 = { class: "list-item" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "list-label" }, "设备IP：", -1))
const _hoisted_24 = { class: "list-content copyable-text" }
const _hoisted_25 = { class: "list-item list-item__samba" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "list-label" }, "Samba：", -1))
const _hoisted_27 = { class: "list-content about-smb" }
const _hoisted_28 = { class: "about-device-smb" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Windows：", -1))
const _hoisted_30 = { class: "copyable-text" }
const _hoisted_31 = { class: "about-device-smb" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Mac OS：", -1))
const _hoisted_33 = { class: "copyable-text" }
const _hoisted_34 = {
  key: "hardware",
  class: "tab-content"
}
const _hoisted_35 = { class: "about-list" }
const _hoisted_36 = { class: "list-label" }
const _hoisted_37 = { class: "list-content" }
const _hoisted_38 = { class: "x-modal__footer" }
const _hoisted_39 = { class: "operations" }
const _hoisted_40 = ["disabled"]
const _hoisted_41 = { class: "popover-container" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "popover-header" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "icomoon-icon icomoon-warn popover-header-icon" }),
  /*#__PURE__*/_createElementVNode("span", { class: "popover-title" }, "确定要关机盒子设备吗？")
], -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "popover-content" }, null, -1))
const _hoisted_44 = { class: "popover-footer" }
const _hoisted_45 = ["disabled"]
const _hoisted_46 = { class: "popover-container" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "popover-header" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "icomoon-icon icomoon-warn popover-header-icon" }),
  /*#__PURE__*/_createElementVNode("span", { class: "popover-title" }, "确定要重启盒子设备吗？")
], -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "popover-content" }, null, -1))
const _hoisted_49 = { class: "popover-footer" }

import { computed, onMounted, ref, watch } from 'vue'
import copy from 'clipboard-copy'
import { usePromisifyDialog } from '@shared/utils/dialog'
import SVGIcon from '@remote/components/SVGIcon.vue'
import DeviceStatusBadge from '@remote/components/business/DeviceStatusBadge.vue'
import XPopover from '@remote/components/Popover.vue'
import EditableInput from '@remote/components/EditableInput.vue'
import { store } from '@remote/store'
import { checkState } from '@remote/store/utils'
import { getDeviceList as getDeviceListApi, updateDeviceName } from '@remote/api/adapter/api-http/index'
import { rebootDevice, shutdownDevice } from '@remote/api/adapter/xos-mqtt'
import { noop } from '@remote/utils/base'
import { toast } from '@remote/utils/dialog'
import type { IDeviceInfo } from '@remote/type/device'

// function logs (..._args) {
//   console.log('[设备详情弹窗]', ..._args)
// }

interface IProps {
  closeOnMaskClick?: boolean
}
interface IEmits {
  (e: 'dialog-close'): void
}

export default /*#__PURE__*/_defineComponent({
  props: {
    closeOnMaskClick: { type: Boolean, default: false }
  },
  emits: ["dialog-close"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'dialog-close'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { closeOnMaskClick: boolean }





// const isMountedRef = ref(false)
const isEditing = ref(false)

const { close } = usePromisifyDialog(emit)
function onClose (evt: MouseEvent, callback = noop) {
  if (isEditing.value) return
  setTimeout(() => {
    close(null)
    callback()
  }, 0)
}

function onMaskClick (evt) {
  if (!props.closeOnMaskClick) return
  if (isEditing.value) return
  onClose(evt)
}

const currentTab = ref<'basic' | 'hardware'>('basic')
const curDeviceRunner = computed(() => store.state.curDeviceRunner)
const deviceId = computed(() => curDeviceRunner.value.params?.target || '')
const deviceDetail = ref<Pick<IDeviceInfo, 'hardwareinfo' | 'cookie'>>({ hardwareinfo: [], cookie: '' })
const isLock = ref(false)
const disabled = computed(() => store.state.curDeviceRunner.status !== 1 || isLock.value)

const shutdownPopoverVisible = ref(false)
const rebootPopoverVisible = ref(false)

const getDeviceList = () => {
  getDeviceListApi()
    .then(res => {
      const [err, result] = res
      if (!err && result?.ret === 0) {
        const target = result.data.list?.find(item => item.device_id === deviceId.value)
        if (target) deviceDetail.value = target
      }
    })
}

onMounted(() => {
  getDeviceList()
})

watch(disabled, () => {
  getDeviceList()
})

function filterInputValue (text: string) {
  let val = ''
  for (let i = 0, c = 0; i < text.length; ++i) {
    const char = text.charAt(i)
    if (char.match(/[\u4e00-\u9fa5]/) || char.match(/[\u9FA6-\u9fcb]/)) {
      c += 3
    } else {
      c += 1
    }
    if (c >= 60) break
    val += text[i]
  }
  return val
}
const renameRules: any[] = [
  {
    timing: 'input',
    min: 0,
    max: 60,
  },
  {
    timing: 'input',
    // 高版本浏览器可使用正则
    // pattern: /\p{Unified_Ideograph}/u,
    validator: (text: string) => {
      let iTotal = 0
      for (let i = 0; i < text.length; i++) {
        let c = text.charAt(i)
        // 匹配汉字
        if (c.match(/[\u4e00-\u9fa5]/) || c.match(/[\u9FA6-\u9fcb]/)) {
          iTotal++
        }
      }

      if (iTotal > 20) return false
      // 一个汉字占3个字节
      if (text.length + iTotal * 2 > 60) return false
      return true
    },
  },
]
function onRename (name: string) {
  rename(name).then((isOK: boolean) => {
    if (isOK) isEditing.value = false
  })
}

function rename (name: string) {
  if (checkState(true, false, false, false)) return Promise.resolve(false)
  if (disabled.value) {
    toast({type: 'warn', message: '设备已离线暂不支持修改'})
    return Promise.resolve(false)
  }

  return updateDeviceName({ cookie: '', device_id: deviceId.value }, name).then(res => {
    const [err, result] = res
    if (!err && result.ret === 0) {
      toast({type: 'success', message: '修改成功'})
      store.commit('update', {
        curDeviceRunner: Object.assign({}, curDeviceRunner.value, { name }),
      })
      return Promise.resolve(true)
    } else {
      toast({type: 'error', message: err?.error_description || result.msg})
      return Promise.resolve(false)
    }
  }).catch(err => {
    toast({type: 'error', message: err})
    return Promise.resolve(false)
  })
}

function toggleRebootPopoverVisible () {
  const visible = rebootPopoverVisible.value
  rebootPopoverVisible.value = !visible
}
function toggleShutdownPopoverVisible () {
  const visisble = shutdownPopoverVisible.value
  shutdownPopoverVisible.value = !visisble
}
function reboot (evt: MouseEvent) {
  rebootPopoverVisible.value = false
  isLock.value = true
  rebootDevice(deviceId.value, deviceDetail.value.cookie).then(res => {
    if (res.ret === 0) {
      // 确认重启/关机后，关闭弹窗
      onClose(evt, () => toast({type: 'loading', message: '设备重启中，请耐心等待...'}))
      store.commit('update', {
        status: 3,
        curDeviceRunner: Object.assign({}, curDeviceRunner.value, { status: 3 }),
      })
    } else {
      toast({type: 'error', message: res.msg || '设备重启失败'})
    }
  }).catch(err => {
    toast({type: 'error', message: err})
  }).finally(() => {
    isLock.value = false
  })
}
function shutdown (evt: MouseEvent) {
  shutdownPopoverVisible.value = false
  isLock.value = true
  shutdownDevice(deviceId.value, deviceDetail.value.cookie).then(res => {
    if (res.ret === 0) {
      // 确认重启/关机后，关闭弹窗
      onClose(evt, () => toast({type: 'loading', message: '设备关机中，请耐心等待...'}))
      store.commit('update', {
        status: -1,
        curDeviceRunner: Object.assign({}, curDeviceRunner.value, { status: -1 }),
      })
    } else {
      toast({type: 'error', message: res.msg || '设备关机失败'})
    }
  }).catch(err => {
    toast({type: 'error', message: err})
  }).finally(() => {
    isLock.value = false
  })
}

const handleOnCopy = (text: string) => {
  copy(text)
  toast({type: 'success', message: '复制成功'})
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "x-modal__mask",
        onClick: _withModifiers(onMaskClick, ["self"])
      }, null, 8, _hoisted_2),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", {
              key: "basic",
              class: _normalizeClass(["tab-item", { 'is-current': currentTab.value === 'basic' }]),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (currentTab.value = 'basic'))
            }, _hoisted_7, 2),
            _createElementVNode("div", {
              key: "hardware",
              class: _normalizeClass(["tab-item", { 'is-current': currentTab.value === 'hardware' }]),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (currentTab.value = 'hardware'))
            }, _hoisted_9, 2)
          ]),
          _createElementVNode("div", {
            class: "x-modal__close",
            onClick: onClose
          }, _hoisted_11)
        ]),
        _createElementVNode("div", _hoisted_12, [
          _withDirectives(_createElementVNode("section", _hoisted_13, [
            _createElementVNode("ul", _hoisted_14, [
              _createElementVNode("li", _hoisted_15, [
                _hoisted_16,
                _createVNode(EditableInput, {
                  class: "list-content",
                  value: _unref(curDeviceRunner).name,
                  rules: renameRules,
                  filter: filterInputValue,
                  editing: isEditing.value,
                  "onUpdate:editing": _cache[2] || (_cache[2] = ($event: any) => ((isEditing).value = $event)),
                  onChange: onRename
                }, null, 8, ["value", "editing"])
              ]),
              _createElementVNode("li", _hoisted_17, [
                _hoisted_18,
                _createElementVNode("span", _hoisted_19, _toDisplayString(_unref(curDeviceRunner).target), 1),
                _createElementVNode("span", {
                  class: "copy-btn",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (handleOnCopy(_unref(curDeviceRunner).target)))
                }, [
                  _createVNode(SVGIcon, { name: "cpy" })
                ])
              ]),
              _createElementVNode("li", _hoisted_20, [
                _hoisted_21,
                _createVNode(DeviceStatusBadge, {
                  class: "list-content",
                  status: _unref(curDeviceRunner).status
                }, null, 8, ["status"])
              ]),
              _createElementVNode("li", _hoisted_22, [
                _hoisted_23,
                _createElementVNode("span", _hoisted_24, _toDisplayString(_unref(curDeviceRunner)?.params?.lan_ip), 1),
                _createElementVNode("span", {
                  class: "copy-btn",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (handleOnCopy(`${_unref(curDeviceRunner)?.params?.lan_ip}`)))
                }, [
                  _createVNode(SVGIcon, { name: "cpy" })
                ])
              ]),
              _createElementVNode("li", _hoisted_25, [
                _hoisted_26,
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, [
                    _hoisted_29,
                    _createElementVNode("span", _hoisted_30, "\\\\" + _toDisplayString(_unref(curDeviceRunner)?.params?.lan_ip), 1),
                    _createElementVNode("span", {
                      class: "copy-btn",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (handleOnCopy(`\\\\${_unref(curDeviceRunner)?.params?.lan_ip}`)))
                    }, [
                      _createVNode(SVGIcon, { name: "cpy" })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_31, [
                    _hoisted_32,
                    _createElementVNode("span", _hoisted_33, "smb://" + _toDisplayString(_unref(curDeviceRunner)?.params?.lan_ip), 1),
                    _createElementVNode("span", {
                      class: "copy-btn",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (handleOnCopy(`smb://${_unref(curDeviceRunner)?.params?.lan_ip}`)))
                    }, [
                      _createVNode(SVGIcon, { name: "cpy" })
                    ])
                  ])
                ])
              ])
            ])
          ], 512), [
            [_vShow, currentTab.value === 'basic']
          ]),
          _withDirectives(_createElementVNode("section", _hoisted_34, [
            _createElementVNode("ul", _hoisted_35, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(deviceDetail.value.hardwareinfo, (item, i) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: i,
                  class: "list-item"
                }, [
                  _createElementVNode("label", _hoisted_36, _toDisplayString(item.label) + "：", 1),
                  _createElementVNode("span", _hoisted_37, _toDisplayString(item.value), 1)
                ]))
              }), 128))
            ])
          ], 512), [
            [_vShow, currentTab.value === 'hardware']
          ])
        ]),
        _createElementVNode("div", _hoisted_38, [
          _createElementVNode("div", _hoisted_39, [
            _createVNode(XPopover, {
              visible: !_unref(disabled) && shutdownPopoverVisible.value,
              align: "top-right",
              onClose: _cache[8] || (_cache[8] = ($event: any) => (shutdownPopoverVisible.value = false))
            }, {
              reference: _withCtx(() => [
                _createElementVNode("button", {
                  class: _normalizeClass(["operation impt", { disabled: _unref(disabled) }]),
                  disabled: _unref(disabled),
                  onClick: toggleShutdownPopoverVisible
                }, " 设备关机 ", 10, _hoisted_40)
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_41, [
                  _hoisted_42,
                  _hoisted_43,
                  _createElementVNode("div", _hoisted_44, [
                    _createElementVNode("button", {
                      class: "popover-button impt",
                      onClick: shutdown
                    }, " 关机 "),
                    _createElementVNode("button", {
                      class: "popover-button light",
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (shutdownPopoverVisible.value = false))
                    }, " 暂不 ")
                  ])
                ])
              ]),
              _: 1
            }, 8, ["visible"]),
            _createVNode(XPopover, {
              visible: !_unref(disabled) && rebootPopoverVisible.value,
              align: "top-right",
              style: { marginLeft: '10px' },
              onClose: _cache[10] || (_cache[10] = ($event: any) => (rebootPopoverVisible.value = false))
            }, {
              reference: _withCtx(() => [
                _createElementVNode("button", {
                  class: _normalizeClass(["operation light", { disabled: _unref(disabled) }]),
                  disabled: _unref(disabled),
                  onClick: toggleRebootPopoverVisible
                }, " 设备重启 ", 10, _hoisted_45)
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_46, [
                  _hoisted_47,
                  _hoisted_48,
                  _createElementVNode("div", _hoisted_49, [
                    _createElementVNode("button", {
                      class: "popover-button impt",
                      onClick: reboot
                    }, " 重启 "),
                    _createElementVNode("button", {
                      class: "popover-button light",
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (rebootPopoverVisible.value = false))
                    }, " 暂不 ")
                  ])
                ])
              ]),
              _: 1
            }, 8, ["visible"])
          ])
        ])
      ])
    ])
  ]))
}
}

})